<template>
  <div class="collapse" :id="id">
    <slot/>
  </div>

  <div class="collapsible clickable collapsed"
       @click="toggle"
       data-bs-toggle="collapse"
       :data-bs-target="'#' + id"
       aria-expanded="false"
       :aria-controls="id">
    <span v-if="collapsed">
      {{ textCollapsed }}
      <img class="chevron-down" src="@/assets/chevron-down.svg" :alt="textCollapsed">
    </span>
    <span v-else>
      {{ textOpen }}
      <img class="chevron-up" src="@/assets/chevron-up.svg" :alt="textOpen">
    </span>

  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'Collapsible',
  props: [
    'textOpen',
    'textCollapsed'
  ],
  data: () => {
    return {
      collapsed: true,
      id: ''
    }
  },
  methods: {
    toggle() {
      this.collapsed = !this.collapsed;
    }
  },
  created() {
    this.id = `collapsible-${Math.floor(Math.random() * 1000)}`;
  }
});
</script>

<style lang="scss">
</style>
